import { createApp } from 'vue';
import cmpBundleView from '../vue/BundleView.vue';

window.BundleView = (function(){
	const component = createApp(cmpBundleView, {
		bundleInfo: window.bundleInfo // todo: rename
	});
	delete window.bundleInfo; // todo: rename
	return component.mount('#component-bundle-view');
})();